export default "__VITE_ASSET__RXDwEW$S__"